"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignList = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var DesignList = /** @class */ (function (_super) {
    __extends(DesignList, _super);
    function DesignList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSectionContent = function () {
            var _a;
            var iconListView = [];
            (_a = _this.props.iconList) === null || _a === void 0 ? void 0 : _a.map(function (eachIcon, index) {
                iconListView.push(react_1.default.createElement("div", { key: index, className: "flex flex-col gap-y-1" },
                    react_1.default.createElement("dt", { className: "flex flex-col items-center self-center font-semibold text-xl text-gray-900" },
                        eachIcon.icon,
                        eachIcon.name),
                    react_1.default.createElement("dd", { className: "inline text-justify" }, eachIcon.content)));
                return null;
            });
            return iconListView;
        };
        return _this;
    }
    DesignList.prototype.render = function () {
        var defaultClassName = "mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base leading-7 text-gray-600 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16";
        if (this.props.className) {
            defaultClassName += " ".concat(this.props.className);
        }
        return react_1.default.createElement("dl", { className: defaultClassName }, this.renderSectionContent());
    };
    return DesignList;
}(react_1.Component));
exports.DesignList = DesignList;
//# sourceMappingURL=index.js.map